import { Box, LinearProgress } from '@mui/material'
import styled from 'styled-components'
import React from 'react'

export const ProfileLeftPannelContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  font-family: Outfit;
  font-style: normal;
  padding: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  
  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
  
  @media (min-width: 1280px) {
    padding: 20px;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
  }
`

export const BackHomeText = styled.div`
  width: 100%;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  font-family: Outfit;
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  margin-bottom: 12px;
  flex-shrink: 0;
  
  @media (orientation: portrait) {
    position: fixed;
    top: ${(props) => (props?.isMobile ? '40px' : '0px')};
    padding: 0 25px;
    background: #18191c;
    justify-content: space-between;
  }
  
  @media (min-width: 1280px) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`

export const LogoutForMobile = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  @media (orientation: landscape) {
    display: none;
  }
`

export const DisplayFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const ProfileInfoCard = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  /* Glass effect */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  
  @media (min-width: 1280px) {
    padding: 16px;
    border-radius: 16px;
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
    border-radius: 10px;
    gap: 8px;
  }
`

export const ProfileCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const ProfilePicture = styled.div`
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-image: url(${(props) => props.imgURL});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
  position: relative;
  border: 2px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  
  @media (min-width: 1280px) {
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
  }
  
  @media (max-width: 480px) {
    flex: 0 0 44px;
    width: 44px;
    height: 44px;
  }
`

export const ProfileIntitial = styled.div`
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
  background: linear-gradient(116.72deg, #cc2b5e 6.79%, #753a88 108.41%);
  font-size: 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  border: 2px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  
  @media (min-width: 1280px) {
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
    font-size: 28px;
  }
  
  @media (max-width: 480px) {
    flex: 0 0 44px;
    width: 44px;
    height: 44px;
    font-size: 20px;
  }
`

export const CameraIcon = styled.img`
  position: absolute;
  bottom: -2px;
  right: -2px;
  height: 20px;
  width: 20px;
  cursor: pointer;
  border-radius: 50%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.5);
  padding: 2px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  
  @media (min-width: 1280px) {
    height: 24px;
    width: 24px;
  }
  
  @media (max-width: 480px) {
    height: 18px;
    width: 18px;
  }
`

export const ProfileCardContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

export const ProfileCardNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const MembershipStatusBox = styled.div`
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  /* Glass effect */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 100%);
  backdrop-filter: blur(10px) saturate(180%);
  -webkit-backdrop-filter: blur(10px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  transition: all 0.3s ease;
  
  @media (min-width: 1280px) {
    padding: 10px 12px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    padding: 6px 8px;
    border-radius: 6px;
  }
`

export const MembershipText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 10px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  flex: 1;
  min-width: 0;
  
  @media (min-width: 1280px) {
    font-size: 11px;
  }
  
  @media (max-width: 480px) {
    font-size: 9px;
  }
`

export const ProfileMembership = styled.div`
  color: #f3ff6e;
  font-size: 14px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 700;
  text-align: left;
  line-height: 1.3;
  
  @media (min-width: 1280px) {
    font-size: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
`

export const ProfileUpgradeButton = styled.button`
  border-radius: 12px;
  background: linear-gradient(180deg, #61f6ff 0%, #1e7fcb 100%);
  font-weight: 600;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1f1f1f;
  padding: 4px 10px;
  flex-shrink: 0;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(97, 246, 255, 0.4);
  }
  
  @media (min-width: 1280px) {
    font-size: 12px;
    padding: 5px 12px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
    padding: 3px 8px;
  }
`

export const IndeterminateLoading = () => {
  return (
    <Box sx={{ width: '50px', position: 'absolute', bottom: '0', right: '-50px' }}>
      <LinearProgress />
    </Box>
  )
}

export const ProfileName = styled.div`
  color: rgba(255, 255, 255, 0.95);
  font-size: 16px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  @media (min-width: 1280px) {
    font-size: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
  }
`

export const ProfileId = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  @media (min-width: 1280px) {
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
  }
`

export const ProfileOptionsList = styled.div`
  margin-top: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`

export const ProfileOption = styled.div`
  align-items: center;
  display: flex;
  min-height: 40px;
  padding: 10px 14px;
  width: 100%;
  flex-shrink: 0;
  margin-bottom: 8px;
  font-family: Outfit;
  font-style: normal;
  font-weight: ${(props) => (props.isSelected ? '600' : '400')};
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => (props?.optionId === 'logout' ? '#ffaaaa' : 'rgba(255, 255, 255, 0.9)')};
  /* Glass effect */
  background: ${(props) => 
    props.isSelected 
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%)'
      : 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)'
  };
  backdrop-filter: blur(10px) saturate(180%);
  -webkit-backdrop-filter: blur(10px) saturate(180%);
  border: ${(props) => 
    props.isSelected 
      ? '1px solid rgba(255, 255, 255, 0.3)' 
      : '1px solid rgba(255, 255, 255, 0.1)'
  };
  border-radius: 12px;
  box-shadow: ${(props) => 
    props.isSelected 
      ? '0 4px 20px rgba(0, 0, 0, 0.2), 0 2px 10px rgba(0, 0, 0, 0.15)' 
      : '0 2px 10px rgba(0, 0, 0, 0.05)'
  };
  transition: all 0.3s ease;
  
  &:hover {
    cursor: pointer;
    background: ${(props) => 
      props.isSelected 
        ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%)'
        : 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)'
    };
    border-color: rgba(255, 255, 255, 0.25);
    transform: translateX(4px);
    box-shadow: ${(props) => 
      props.isSelected 
        ? '0 6px 24px rgba(0, 0, 0, 0.25), 0 3px 12px rgba(0, 0, 0, 0.2)' 
        : '0 4px 16px rgba(0, 0, 0, 0.1)'
    };
  }
  
  @media (min-width: 1280px) {
    min-height: 44px;
    font-size: 15px;
    padding: 12px 16px;
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    min-height: 38px;
    font-size: 13px;
    padding: 8px 12px;
    margin-bottom: 6px;
    border-radius: 10px;
  }
`

export const ProfileOptionIcon = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 10px;
  flex-shrink: 0;
  
  @media (min-width: 1280px) {
    height: 22px;
    width: 22px;
    margin-right: 12px;
  }
  
  @media (max-width: 480px) {
    height: 18px;
    width: 18px;
    margin-right: 8px;
  }
`
